import { render, staticRenderFns } from "./MyAppliedLoans.vue?vue&type=template&id=88c7a47a&"
import script from "./MyAppliedLoans.vue?vue&type=script&lang=js&"
export * from "./MyAppliedLoans.vue?vue&type=script&lang=js&"
import style0 from "./MyAppliedLoans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports